export const getLoginState = state => state.isLogined

export const getToken = state => state.token

export const getUser = state => state.user
